module.exports = __webpack_public_path__ + "img/Cuba.fc2337c3.png";